import { useEffect, useRef } from 'react';

/* Страница показана браузером из back/forward cache (pageshow с persisted): состояние на момент
 *  ухода восстановлено как есть, React ничего не перерисовывал. Колбэк получает шанс вернуть
 *  экран в рабочее состояние (payment-buttons, R-10, walkthrough шаг 11). */
export const usePageRestore = (onRestore: () => void) => {
  const onRestoreRef = useRef(onRestore);

  onRestoreRef.current = onRestore;

  useEffect(() => {
    const onPageShow = (event: PageTransitionEvent) => {
      if (event.persisted) {
        onRestoreRef.current();
      }
    };

    window.addEventListener('pageshow', onPageShow);

    return () => window.removeEventListener('pageshow', onPageShow);
  }, []);
};
